export const snackBarStyle = (type = "success" , duration = 1500 , verticalPos = 'top' , horizontalPos = 'center') => {
    const style = {
        variant: type,
        autoHideDuration: duration,
        anchorOrigin: {
            vertical: verticalPos,
            horizontal: horizontalPos,
        },

    }
    return style
}